import Button from '@src/ui/elements/button/Button';
import StatusTip from '@src/ui/elements/table/StatusTip';
import { FC } from 'react';

import { TagItemType } from './TagTable';

type TagItemProps<T> = {
  item: TagItemType;
  handleEditClick?: (item: T) => void;
};

const TagItem: FC<TagItemProps<TagItemType>> = ({ item, handleEditClick }) => {
  return (
    <tr className='h-[60px] transition-colors [&:nth-child(2n+1)]:bg-gray-10'>
      <td className='px-4'>
        <div className='flex items-center truncate'>
          <span className='truncate'>{item.id}</span>
        </div>
      </td>
      <td className='px-4'>
        <div className='flex items-center truncate'>
          <span className='truncate'>{item.name}</span>
        </div>
      </td>
      <td className='px-4'>
        <div className='flex items-center'>
          {item.enabled ? (
            <StatusTip
              label='有効'
              active={true}
            />
          ) : (
            <StatusTip
              label='無効'
              active={false}
            />
          )}
        </div>
      </td>
      <td
        width={130}
        className='py-[9px]'
      >
        {(item.editable === undefined || item.editable === 1) && (
          <Button
            size='s'
            variant='quaternary'
            outline
            onClick={() => handleEditClick && handleEditClick(item)}
          >
            編集する
          </Button>
        )}
      </td>
    </tr>
  );
};

export default TagItem;
